// extracted by mini-css-extract-plugin
export default {"label":"ActionLabel_label__IJL1x","icon":"ActionLabel_icon__NUqGP","light":"ActionLabel_light__Ljsd+","right":"ActionLabel_right__QQmit","row":"ActionLabel_row__d6vrp"};